import { useMemo, type FC } from "react"

import type { PowerlinePlotDef } from "types/dashboard.types"

import { useNominalAmpacityViews } from "helpers/hooks/plots/useNominalAmpacityViews"
import PowerlineTelemetryPlot from "./PowerlineTelemetryPlot"

interface PowerlinePlotProps {
  def: PowerlinePlotDef
  powerlineIds: number[]
}

const PowerlinePlot: FC<PowerlinePlotProps> = ({ def, powerlineIds }) => {
  const { view } = useNominalAmpacityViews(def, powerlineIds[0])
  const formattedDef = useMemo(
    () => ({
      ...def,
      view,
    }),
    [def, view],
  )
  return <PowerlineTelemetryPlot def={formattedDef} powerlineIds={powerlineIds} />
}

export default PowerlinePlot
